import { PhoneOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";

import { isAuthenticated } from "../helpers/common";
import { LocalStorageKey } from "../constants/localStorageKeys";
import
{
  getCurrentUser,
  getUserPhone,
  getUserPhoneHref,
  ICurrentUser,
} from "../services/userService";

const getAuthMethod = (): string | undefined =>
{
  try
  {
    return JSON.parse(
      localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "{}",
    )?.REACT_APP_AUTHENTICATION_METHOD;
  } catch
  {
    return undefined;
  }
};

/**
 * The logged-in user's phone in the header, as a `tel:` link. Only OAUTH2 has
 * this profile source (`/api/v1/users/me`), and the element renders nothing
 * until a number actually comes back — so no empty pill sits in the header.
 */
export default function HeaderPhone()
{
  const [currentUser, setCurrentUser] = useState<ICurrentUser | undefined>();
  const mountedRef = useRef(true);

  const authMethod = getAuthMethod();

  // Tracked in its own effect so the fetch below never registers a cleanup that
  // would cancel its own in-flight call when the deps change.
  useEffect(() =>
  {
    mountedRef.current = true;
    return () =>
    {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() =>
  {
    if (authMethod !== "OAUTH2" || !isAuthenticated()) return;

    getCurrentUser().then((user) =>
    {
      if (mountedRef.current) setCurrentUser(user);
    });
  }, [authMethod]);

  const phone = getUserPhone(currentUser);
  if (!phone) return null;

  return (
    <a
      href={getUserPhoneHref(currentUser)}
      className="h-10 px-4 flex items-center gap-2 rounded-[100px] bg-[#2b3a55] border border-[#35486F] hover:bg-[#33466a] text-white hover:text-white transition"
    >
      <PhoneOutlined className="text-base" />
      <span className="whitespace-nowrap">{phone}</span>
    </a>
  );
}
